import person_icon from "../../images/ProgressBarIcons/complete_icons/Personal.png";
import shipping_icon from "../../images/ProgressBarIcons/incomplete_icons/Shipping.png";
import credit_card from "../../images/ProgressBarIcons/incomplete_icons/Payment.png";
import review_icon from "../../images/ProgressBarIcons/incomplete_icons/Review.png";
import heart_icon from "../../images/ProgressBarIcons/incomplete_icons/Thanks.png";

import OrganizationInfoForm from "../../components/Forms/StartingYourFundraiser/Step1-OrganizationInfo/OrganizationInfoForm";
import ProgressBar, { Step } from "../../components/ProgressBar/ProgressBar";
import { useEffect } from "react";

const OrganizationInfo = () => {
  const progress_bar_props: Step[] = [
    { icon: person_icon, label: "Organization Info" },
    { icon: shipping_icon, label: "Fundraiser Info" },
    { icon: credit_card, label: "Primary/Secondary" },
    { icon: review_icon, label: "Assign Participants" },
    { icon: heart_icon, label: "Review & Create" },
  ];
  const currentStep: number = 1;
  useEffect(() => {
    document.title = "Create Your Fundraiser";
  }, []);

  return (
    <div className="page-wrapper">
      <h2>Starting your Fundraiser</h2>
      <div className="progress-bar">
        <ProgressBar steps={progress_bar_props} currentStep={currentStep} />
      </div>
      <OrganizationInfoForm />
    </div>
  );
};

export default OrganizationInfo;
